import { useTLang } from 'intl/intl';

export function useScheduledOrdersListLang() {
  return {
    listTitle: useTLang({ id: 'scheduleOrder.listTitle' }),
    emptyTitle: useTLang({ id: 'scheduleOrder.emptyTitle' }),
    emptyDescription: useTLang({ id: 'scheduleOrder.emptyDescription' }),
  };
}
